/* Product list item helpers */

// updateProductListItemPositions
function updateProductListItemPositions() {
	const productCards = Array.from(document.querySelectorAll(".product-list-item:not(.product-list-promo)"));

	const remainginProducts = [];

	let index = productCards.reduce((highest, element) => {
		if (element.dataset.position && element.dataset.id) {
			const position = parseInt(element.dataset.position);
			if (position > highest) {
				return position;
			}
		} else if (element.dataset.id) {
			remainginProducts.push(element);
		}
		return highest;
	}, 0);

	for (const element of remainginProducts) {
		if (!element.dataset.position && element.dataset.id) {
			element.dataset.position = index + 1;
			// For now let's update position only for products and not promos or product packages.
			index++;
		}
	}
}

/**
 * Creates an object to use in datalayer from product-list-item.
 *
 * @param {Object} productItem - product-list-item dom node (not jquery).
 *
 * @return {Object} Product info for datalayer.
 */
function getProductDataLayerData(productItem) {
	if (!productItem || !productItem?.dataset) {
		return false;
	}
	const { identifier, id, colorName, name, brand, price } = productItem.dataset;
	let { position } = productItem.dataset;

	if (!position) {
		updateProductListItemPositions();
		position = productItem.dataset.position;
	}

	const link = productItem?.querySelector("a.product-link");
	if (!link || !id) {
		return false;
	}
	const url = link.getAttribute("href");

	const list = productItem.closest(".product-carousel") ? "Karuselli" : productItem.closest("#search-page") ? "Tuotehaku" : "Tuotelistaus";
	const category = String(window.location.href).replace(window.location.origin, "");

	return {
		id,
		price,
		list,
		link: url,
		name,
		brand,
		category,
		variant: colorName,
		position: parseInt(position),
		dimension23: identifier
	};
}

export { updateProductListItemPositions, getProductDataLayerData };
